export default __webpack_public_path__ + "img/1c1f9e20e9b527534884cc53a92826a9.png";